import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './BlogDetail.css';

function BlogDetail() {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`https://mimagtech.com/bombaydentalcompany/bombaydentalcompanyapi/add_blog.php`);
        setBlog(response.data);
      } catch (err) {
        setError('Failed to fetch blog details');
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [id]);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  if (!blog) {
    return <div className="blog-not-found">Blog not found</div>;
  }

  return (
    <div className="blog-detail">
      <h1 className="blog-detail-title">{blog.title}</h1>
      <p className="blog-meta">{blog.date} | {blog.category}</p>
      <img src={blog.image} alt={blog.title} className="blog-detail-image" />
      <p className="blog-detail-content">{blog.content}</p>
    </div>
  );
}

export default BlogDetail;
